import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import tmdbApi from "../../api/tmdbApi";
import apiConfig from "../../api/apiConfig";

const StreamingList = (props) => {
  const { category } = useParams();
  const [platforms, setPlatforms] = useState([]);
  const notAvailable = 1;
  useEffect(() => {
    const getPlatform = async () => {
      const res = await tmdbApi.platform(category, props.id);
      if (res.results.IN === undefined) {
        setPlatforms(notAvailable);
      } else {
        if (res.results.IN.flatrate === undefined) {
          setPlatforms(2);
        } else {
          // console.log(res.results.IN);
          setPlatforms(res.results.IN.flatrate.slice(0, 5));
        }
      }
    };

    getPlatform();
  }, [category, props.id]);

  return (
    <>
      {platforms === 1 || platforms === 2 ? (
        <div style={{ color: "#fac228" }}>Not available on any OTT platform in India</div>
      ) : (
        <div className="section_header">
          <h2>Available&nbsp;on</h2>
          <div className="platform">
            {platforms.map((item, i) => (
              <div key={i} className="platform__item">
                <div
                  className="platform__item__img"
                  style={{
                    backgroundImage: `url(${apiConfig.w500Image(
                      item.logo_path
                    )})`,
                  }}
                ></div>
                <p className="platform__item__name">{item.provider_name}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default StreamingList;
